/*
 * Public API Surface of ng-gallery
 */

export * from './lib/ng-gallery.service';
export * from './lib/ng-gallery.component';
export * from './lib/ng-gallery.module';
